function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.32 40.41v-3.6H6.2c-1.81 0-3.04-1.55-3.04-3.16v-3.52h-.11C1.22 30.13 0 28.57 0 26.96V7.57c0-1.6 1.23-3.16 3.04-3.16h35.6c1.81 0 3.04 1.56 3.04 3.16v3.53h.11c1.82 0 3.04 1.56 3.04 3.16v3.6h.13c1.82 0 3.04 1.56 3.04 3.16v19.38c0 1.6-1.22 3.16-3.04 3.16H9.36c-1.81 0-3.04-1.55-3.04-3.16zm38.31-.2v-5.44a3.02 3.02 0 01-2.84 2.05H9.7v3.38h34.94zm-3.17-6.76v-5.33a3.01 3.01 0 01-2.82 2H6.52v3.33h34.94zm-3.15-6.7V7.8H3.37v18.97h34.94zM6.43 24.13V10.43h11.6c-1.97 1.28-3.32 3.87-3.32 6.84 0 2.98 1.35 5.57 3.33 6.85H6.43zm20.54-6.85c0-2.98-1.36-5.56-3.33-6.84h11.6v13.69h-11.6c1.97-1.28 3.32-3.87 3.32-6.85z"
})));